import React from 'react';

export const tiktokIcon = ({ ariaLabel = 'TikTok' }) => {
  return (
    <img
      src="/static/icon-tiktok.png"
      alt={ariaLabel}
      width="24"
      height="24"
      style={{ display: 'block' }}
    />
  );
};
